import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { TranslateModule } from '@ngx-translate/core';
import { DpDropdownComponent } from '../../../common-component/dp-dropdown/dp-dropdown.component';
import { DpInputFieldComponent } from '../../../common-component/dp-input-field/dp-input-field.component';
import { FormsModule } from '@angular/forms';
@Component({
  standalone: true,
  selector: 'app-dashboard-grid',
  templateUrl: './dashboard-grid.component.html',
  styleUrl: './dashboard-grid.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    DpTableComponent,
    TranslateModule,
    DpDropdownComponent,
    DpInputFieldComponent,
    CommonModule,
    FormsModule,
  ]
})
export class DashboardGridComponent {
  public tableArr:any = [];
  public isGridView: boolean = true;
  public isListView: boolean = false;

  public users:any = [];
  public hasDashboardGrid: boolean = true;
  public displayColumnData:any = [
    {
      id: 'state',
      name: 'State'
    },
    {
      id: 'active',
      name: 'Active'
    },
    {
      id: 'inactive',
      name: 'Inactive'
    },
    {
      id: 'defaulter',
      name: 'Defaulter'
    },
    {
      id:'stagnant',
      name: 'Stagnant'
    }
  ];
  public placeholderName:string = 'Search PIN/district/state/country';

  cellComponentMap = {}

  constructor(private _commonUtilService: CommonUtilService) {

  }

  ngOnInit() {
    this.users = [];
    console.log(this.users);
    this.tableArr = [
      {
        state: "Andaman and Nicobar",
        active: 20,
        inactive: 30,
        defaulter: 10,
        stagnant: 500,
      },
      {
        state: "Andhra Pradesh",
        active: 20,
        inactive: 30,
        defaulter: 10,
        stagnant: 500,
      },
      {
        state: "Arunachal Pradesh",
        active: 20,
        inactive: 30,
        defaulter: 10,
        stagnant: 500,
      },
      {
        state: "Assam",
        active: 20,
        inactive: 30,
        defaulter: 10,
        stagnant: 500,
      },
      {
        state: "Assam",
        active: 20,
        inactive: 30,
        defaulter: 10,
        stagnant: 500,
      },
    ]
  }



}
